import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "NotSen"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M22.5 21.4425L2.5575 1.5L1.5 2.5575L7.5 8.5575L1.995 10.545C1.70365 10.6555 1.51099 10.9346 1.51099 11.2463C1.51099 11.5578 1.70365 11.837 1.995 11.9475L9.195 14.8275L12.075 22.0275C12.1856 22.3056 12.4509 22.4913 12.75 22.5C13.0603 22.4936 13.3346 22.2969 13.44 22.005L15.45 16.5L21.45 22.5L22.5 21.4425ZM4.35005 11.25L8.65505 9.75L10.9425 12L9.57005 13.3725L4.35005 11.25ZM12.75 19.65L10.6575 14.4L12 13.0575L14.25 15.345L12.75 19.65ZM11.7675 8.58751L17.4975 6.50251L15.4125 12.2325L16.5825 13.4025L19.455 5.50501C19.5537 5.23156 19.4854 4.92573 19.2799 4.72018C19.0743 4.51462 18.7685 4.44636 18.495 4.54501L10.5975 7.41751L11.7675 8.58751Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/NotSen.vue"]]);
